import { ComparativeSection } from '../../utils/comparativeSectionUtil';
import { mergeYmdLists } from '../chain/date';

/**
 * 平日/土日祝比較のときに ymdList と ymdComparisonList をマージして
 * ymdList のみを残し、ymdComparisonList を取り除いた params を返す。
 * それ以外の比較区分では params から ymdComparisonList のみを取り除いて返す。
 *
 * ymdComparisonList を受け付けない API（summary / kado graph）向けに
 * 検索条件を組み立てるために使用する。
 */
export const buildMergedYmdListParams = <
  T extends { ymdList?: string[]; ymdComparisonList?: string[] }
>(
  params: T,
  comparativeSection: ComparativeSection | undefined
): Omit<T, 'ymdComparisonList'> => {
  const { ymdComparisonList, ...rest } = params;
  if (comparativeSection !== '平日/土日祝比較') {
    return rest;
  }
  return {
    ...rest,
    ymdList: mergeYmdLists(params.ymdList, ymdComparisonList),
  };
};
